import {
  FunctionComponent,
  createContext,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { AuthContextType } from '../types/AuthContext';
import { UserLogin } from '../types/Authorization';
import { getstoreValidation } from '../utils/localstore';
import { setSession } from '../utils/axios';
import CookiesService from '../servies/CookiesService';
// import ModalAccessDeny from '../components/ModalAccessDenyComponent/ModalAccessDenyComponent';

const LOCAL_TOKEN_KEY = 'renegade';

const AuthContext = createContext<AuthContextType | null>(null);

interface AuthProviderProps {
  children: ReactNode;
}
// const expiresAt = 60;
const AuthProvider: FunctionComponent<AuthProviderProps> = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<UserLogin | null>(null);
  // const [isAccessDenyModalOpen, setAccessDenyModalOpen] = useState(false);

  useEffect(() => {
    makeSync();
  }, []);

  const makeSync = (callback: () => void = () => {}) => {
    const userStore = getstoreValidation<string>(LOCAL_TOKEN_KEY);

    if (userStore) {
      let _json: UserLogin = JSON.parse(userStore);
      if (_json.token) {
        const option = { path: '/' };
        console.log('_json', _json);

        setUser(_json);
        setSession(_json.token);
        CookiesService.set('access_token', _json.token, option);
        setIsAuthenticated(true);
        callback();
      }
    } else {
      setSession(null);
      setIsAuthenticated(false);
    }
  };

  const logout = () => {
    // setAccessDenyModalOpen(false);
    setSession(null);
    makeSync();
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,

        user: user || null,
        logout,
        sync: makeSync,
      }}
    >
      {props.children}
      {/* <ModalAccessDeny isOpen={isAccessDenyModalOpen} onAction={logout} /> */}
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext };
